var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkedDataIconDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.416992,
    y: 0.000976562,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22204_80752",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41699 8.00098H24.417V24.001H8.41699V8.00098Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22204_80752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5345 12.0135C22.6416 12.1206 22.7023 12.2653 22.7023 12.417V23.4296C22.7023 23.7456 22.447 24.001 22.1309 24.001H10.7023C10.3862 24.001 10.1309 23.7456 10.1309 23.4296V8.57241C10.1309 8.25633 10.3862 8.00098 10.7023 8.00098H18.2862C18.438 8.00098 18.5844 8.06169 18.6916 8.16883L22.5345 12.0135ZM21.3845 12.6795L18.0237 9.31884V12.6795H21.3845ZM12.988 15.4653C12.9485 15.4653 12.9149 15.4792 12.887 15.5071C12.8591 15.535 12.8451 15.5687 12.8451 15.6081V16.4653C12.8451 16.5047 12.8591 16.5384 12.887 16.5663C12.9149 16.5942 12.9485 16.6081 12.988 16.6081H19.8451C19.8846 16.6081 19.9183 16.5942 19.9462 16.5663C19.974 16.5384 19.988 16.5047 19.988 16.4653V15.6081C19.988 15.5687 19.9741 15.535 19.9462 15.5071C19.9183 15.4792 19.8846 15.4653 19.8451 15.4653H12.988ZM12.988 17.8938C12.9485 17.8938 12.9149 17.9078 12.887 17.9357C12.8591 17.9636 12.8451 17.9972 12.8451 18.0367V18.8939C12.8451 18.9333 12.8591 18.967 12.887 18.9949C12.9149 19.0228 12.9485 19.0367 12.988 19.0367H16.2737C16.3132 19.0367 16.3468 19.0228 16.3747 18.9949C16.4026 18.967 16.4166 18.9333 16.4166 18.8939V18.0367C16.4166 17.9972 16.4026 17.9636 16.3747 17.9357C16.3468 17.9078 16.3132 17.8938 16.2737 17.8938H12.988Z",
    fill: "#BFBFBF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkedDataIconDisable);
export default __webpack_public_path__ + "static/media/workedDataIconDisable.f980142851c91dcc5c6fbcf3d8ff72d1.svg";
export { ForwardRef as ReactComponent };